var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "25",
        viewBox: "0 0 20 25",
      },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("g", { attrs: { fill: _vm.color, "fill-rule": "nonzero" } }, [
          _c("path", {
            attrs: {
              d: "M9.736 15.904A6.19 6.19 0 0 1 3.55 9.718a6.19 6.19 0 0 1 6.186-6.186 6.19 6.19 0 0 1 6.186 6.186 6.19 6.19 0 0 1-6.186\n          6.186zm0-10.59A4.411 4.411 0 0 0 5.33 9.717a4.411 4.411 0 0 0 4.405 4.405 4.411 4.411 0 0 0 4.405-4.405 4.411 4.411 0\n          0 0-4.405-4.405z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M9.712 24.797l-.534-.433c-3.93-3.188-6.66-6.5-8.11-9.855-.48-1.116-.807-2.203-.967-3.235-.125-.82-.101-1.36-.09-1.556v-.03A9.668\n          9.668 0 0 1 2.88 2.85 9.685 9.685 0 0 1 9.742.018a9.477 9.477 0 0 1 6.803 2.855c1.77 1.8 2.808 4.227 2.927 6.833.077\n          1.781-.368 3.669-1.336 5.622-.754 1.52-1.822 3.081-3.182 4.643-2.285 2.63-4.589 4.345-4.684 4.416l-.558.41zm.024-22.998c-2.113\n          0-4.102.819-5.604 2.31a7.903 7.903 0 0 0-2.345 5.585c0 .054 0 .107-.006.16-.012.161-.095 1.627.914 3.948 1.253 2.892 3.68 5.895\n          7.053 8.727 1.911-1.561 8.192-7.136 7.943-12.74-.095-2.166-.956-4.179-2.416-5.663a7.714 7.714 0 0 0-5.54-2.327z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("path", { attrs: { d: "M-3 0h24.747v24.747H-3z" } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }